import axios from 'axios';

export const fetchExtractionConfig = async (accessKey) => {
  const response = await axios.get('/api/extraction-config', { params: { accessKey } });
  return response.data;
};
